__turbopack_context__.v({
  "Container": "_iysfG_Container",
  "Description": "_iysfG_Description",
  "Icon": "_iysfG_Icon",
  "IconHover": "_iysfG_IconHover",
  "IconWrapper": "_iysfG_IconWrapper",
  "Root": "_iysfG_Root",
  "Root--Current": "_iysfG_Root--Current",
  "Root--Disabled": "_iysfG_Root--Disabled",
  "Root--ListClientDashboard": "_iysfG_Root--ListClientDashboard",
  "Root--ToolbarAccount": "_iysfG_Root--ToolbarAccount",
  "TextWrapper": "_iysfG_TextWrapper",
  "Title": "_iysfG_Title",
  "skeleton-loading": "_iysfG_skeleton-loading",
});
